import React from 'react';
import PropTypes from 'prop-types';
import Button from 'src/ui/library/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import styled from 'src/ui/library/styled';
import IconButton from '@material-ui/core/IconButton';
import Clear from '@material-ui/icons/Clear';
//import withMobileDialog from '@material-ui/core/withMobileDialog';

const styles = (theme, props) => ({
  root: {},
  rootPaper: {
    padding: '32px',
    minWidth: '500px',
  },
  title: {
    padding: '0px',
    margin: '0px',
    fontSize: '24px',
    color: theme.colors.eyConfidentGrey,
  },
  divider: {
    marginTop: '40px',
    height: '1px',
    width: '100%',
    border: '0.5px solid #CCC',
    opacity: '0.7',
  },
  contentRoot: {
    padding: '32px 0px 0px 0px',
  },
  contentText: {
    color: theme.colors.eyConfidentGrey,
    fontSize: '14px',
  },
  actionsRoot: {
    margin: '24px 0px 0px 0px',
    justifyContent: 'flex-start',
    width: '100%',
    maxWidth: '400px',
  },
  buttonAction: {
    margin: '0px 16px 0px 0px',
  },
});

class ConfirmDialog extends React.Component {
  static propTypes = {
    /** Open/close dialog */
    open: PropTypes.bool.isRequired,
    /** Text for the Dialog title */
    title: PropTypes.string.isRequired,
    /** Text for the cancel button */
    cancelText: PropTypes.string,
    /** Text for the confirm button */
    confirmText: PropTypes.string.isRequired,
    /** Callback fired when cancel button click */
    onCancel: PropTypes.func,
    /** Callback fired when confirm button click */
    onConfirm: PropTypes.func,
    /** Classes injected from MUI Styles */
    classes: PropTypes.object,
    /** Provided children */
    children: PropTypes.node,
  };

  static defaultProps = {
    maxWidth: 'md',
  };

  constructor(props) {
    super(props);
    this.refInputs = React.createRef();
  }

  componentDidMount() {
    this.focusElement();
  }

  componentDidUpdate() {
    this.focusElement();
  }

  focusElement = () => {
    if (this.refInputs.current) {
      const inputElement = this.refInputs.current.getElementsByTagName('input');
      const firstElement = inputElement.length ? inputElement : this.refInputs.current.getElementsByTagName('button');
      if (firstElement.length) {
        firstElement[0].focus();
      }
    }
  };

  render() {
    const {
      cancelText,
      maxWidth,
      confirmText,
      onCancel,
      onConfirm,
      title,
      classes,
      children,
      open,
      noCancel,
      toggleDrawer = null,
    } = this.props;

    return (
      <Dialog
        maxWidth={maxWidth}
        classes={{ root: classes.root, paper: classes.rootPaper }}
        open={open}
        aria-labelledby="confirm-title"
        aria-describedby="alert-content"
        role="dialog"
        ref={this.refInputs}>
        {!toggleDrawer && (
          <h2 className={classes.title} id="confirm-title">
            {title}
          </h2>
        )}
        {toggleDrawer && (
          <div style={{ display: 'flex' }}>
            <h2 style={{ display: 'flex', alignItems: 'center' }} className={classes.title} id="confirm-title">
              {title}
            </h2>
            <div style={{ marginLeft: 'auto', textAlign: 'center' }} className="close-btn-container">
              <IconButton onClick={toggleDrawer} aria-label="Close Navigation Menu">
                <Clear style={{ color: 'black' }} className="icon lg" />
              </IconButton>
            </div>
          </div>
        )}
        <DialogContent classes={{ root: classes.contentRoot }} id="alert-content">
          <DialogContentText classes={{ root: classes.contentText }} aria-label={typeof children === 'string' ? children : null}>
            {children}
          </DialogContentText>
        </DialogContent>
        <div className={classes.divider} />
        <DialogActions classes={{ root: classes.actionsRoot, spacing: classes.buttonAction }}>
          {!noCancel && (
            <Button onClick={onCancel || null} noMaxWidth={true} styleType={'secondary'} aria-label={cancelText}>
              {cancelText}
            </Button>
          )}
          <Button onClick={onConfirm || null} noMaxWidth={true} aria-label={confirmText}>
            {confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export { ConfirmDialog };
export default styled(ConfirmDialog)(styles);
